import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1300Model } from '../kymw1300.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';

/**
 * 商品企画マスタ画面　選定するサービス
 *
 * @export RegistPlanService
 * @class RegistPlanService
 * @extends {PlessJsonResponderSub<any>}
 */
@Injectable()
export class RegistPlanService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof RegistPlanService
   */
  private model: KYMW1300Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof RegistPlanService
   */
  private vo: {
    orderCode: '',
    mediumType: '',
    sellAreaCode: '',
    orderNumQuotaCode: '',
    featureCode: '',
    bundleCatalogRoundId: '',
    startOrderCode: '',
    endOrderCode: '',
    pCodeList: [],
    orderCodeList: [],
  };

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof RegistPlanService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistPlanService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        RegistPlan: {
          condition: {
            MediumType: this.vo.mediumType,
            SellAreaCode: this.vo.sellAreaCode,
            OrderNumQuotaCode: this.vo.orderNumQuotaCode,
            FeatureCode: this.vo.featureCode,
            BundleCatalogRoundId: this.vo.bundleCatalogRoundId,
          }
        },
        OrderCodeList: {
          combination: this.vo.orderCodeList.map(orderCode => ({
            condition: {
              OrderCode: orderCode
            }
          }))
        },
        RegistPlanPCodeList: {
          combination: this.vo.pCodeList.map(pCode => ({
            condition: {
              PCodeList: pCode
            }
          }))
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof RegistPlanService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW1300Model> model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('registPlan', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistPlanService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
